<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入手机号或邮箱" v-model="keywords"  style="width:300px;margin-right:20px" @change="getData" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="success" plain @click="dialog = true">添加商品</el-button>
            <el-button type="primary" plain @click="$router.push('/market/active/live/user')">查看砍价用户</el-button>
        </div>
        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="630" style="width: 100%">
                <el-table-column label="商品图片" fixed align="center" width="150">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.goods.image" :src="scope.row.goods.image.remote_url" />
                    </template>
                </el-table-column>
                <el-table-column prop="goods_info.name" label="商品名称"  align="center"  width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="活动时间"  align="center" min-width="300">
                    <template slot-scope="scope">
                        {{scope.row.start_time}}<span style="margin:0 10px">至</span>{{scope.row.end_time}}
                    </template>
                </el-table-column>
                <el-table-column prop="sort"    label="排序"      align="center" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort" @change="handleSort(scope.row)" size="small" style="width:100px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品状态"  align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="可否购买"  align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.buy_status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" width="320">
                    <template slot-scope="scope">
                        <div class="tables-btns">
                            <el-popover  placement="top-end" trigger="click">
                                <el-table :data="scope.row.goods_sku" max-height="450">
                                    <el-table-column label="规格图片"  align="center" width="100">
                                        <template slot-scope="scope">
                                            <m-img v-if="scope.row.image" :src=" scope.row.image.remote_url" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="规格" align="center" width="100">
                                        <template slot-scope="scope">{{lang == 'zh' ? scope.row.attr_symbol_string : scope.row.attr_symbol_string_en}}</template> 
                                    </el-table-column>
                                    <el-table-column label="原价(C$)" align="center" width="100">
                                        <template slot-scope="scope">{{scope.row.cost_price}}</template> 
                                    </el-table-column>
                                    <el-table-column label="最低价格(C$)" align="center" width="120">
                                        <template slot-scope="scope"  v-if="scope.row.live_goods_sku">{{scope.row.live_goods_sku.sales_price}}</template> 
                                    </el-table-column>
                                    <el-table-column label="砍价库存" align="center" width="100">
                                        <template slot-scope="scope" v-if="scope.row.live_goods_sku">{{scope.row.live_goods_sku.sales_stock}}</template> 
                                    </el-table-column>
                                    <el-table-column label="砍价次数" align="center" width="100">
                                        <template slot-scope="scope" v-if="scope.row.live_goods_sku">{{scope.row.live_goods_sku.count ? scope.row.live_goods_sku.count : '无限制'}}</template> 
                                    </el-table-column>
                                </el-table>
                                <el-button slot="reference" type="primary" plain size="mini">查看SKU</el-button>
                            </el-popover>
                            <el-button type="success" plain size="mini" @click="handleSku(scope.row)">
                                <span>{{scope.row.edit == 1 ? '修改SKU' : '添加SKU'}}</span>
                            </el-button>
                            <el-button type="success" plain size="mini" @click="handlePut(scope.row)">修改</el-button>
                            <el-button type="danger" plain size="mini" @click="handleDel(scope.row, scope.$index)">移除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="loadPage" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </div>
        <!-- 商品列表 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="1000px" center>
            <el-card shadow="never">
                <div class="m-bottom-3">
                    <el-input v-model="goodsSearch" @change="searchGoods()" clearable placeholder="搜索商品" prefix-icon="el-icon-search" style="margin-right: 20px; width: 180px"></el-input>
                    <el-date-picker v-model="start_time" value-format="timestamp"  type="datetime" placeholder="选择开始时间" style="margin-right:10px"></el-date-picker>
                    <el-date-picker v-model="end_time" value-format="timestamp"  type="datetime" placeholder="选择结束时间" style="margin-right:10px"></el-date-picker>
                </div>
                <el-table :data="goodsData" @selection-change="handleChecked" max-height="450" ref="table" style="width: 100%">
                <el-table-column label="商品图片" align="center">
                    <template slot-scope="scope">
                    <m-img :src="scope.row.image_url"></m-img>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="min_price,max_price" align="center" label="价格" show-overflow-tooltip>
                    <template slot-scope="scope">
                    <div v-if="scope.row.max_price == scope.row.min_price">
                        C${{ scope.row.min_price }}
                    </div>
                    <div v-else>
                        C${{ scope.row.min_price }} - C${{ scope.row.max_price }}
                    </div>
                    </template>
                </el-table-column>
                <el-table-column prop="off" label="是否折扣商品" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                    <span> 
                        {{ scope.row.off ? '是' : '否' }}
                    </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="编辑">
                    <template slot-scope="scope">
                    <el-button size="mini" type="success" plain @click="handleAdd(scope.row)">添加</el-button>
                    </template>
                </el-table-column>
                </el-table>
                <el-pagination background layout="prev, pager, next, jumper" style="padding: 10px" :total="goodsTotal" :page-size="goodsSize" @current-change="goodsMore"></el-pagination>
            </el-card>
        </el-dialog>
        <!-- 修改时间 -->
        <el-dialog title="修改" :visible.sync="timeDialog" width="600px">
            <el-row class="line-item">
               <el-col :span="4" class="item-label">开始时间：</el-col>
               <el-col :span="20">
                   <el-date-picker v-model="start_time" value-format="timestamp"  type="datetime" placeholder="选择开始时间" style="width:100%"></el-date-picker>
               </el-col>
           </el-row>
           <el-row class="line-item">
                <el-col :span="4" class="item-label">结束时间：</el-col>
                <el-col :span="20">
                    <el-date-picker v-model="end_time" value-format="timestamp"  type="datetime" placeholder="选择结束时间" style="width:100%"></el-date-picker>
                </el-col>
           </el-row>
           <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="timeDialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>
    </section>
</template>
<script>

import {  live_goods,add_live_goods, put_live_goods, del_live_goods  } from '@/api/market.js'
import {  goods_list } from "@/api/goods.js"
import { parseTime } from "@/untils/index.js"

import MImg   from '../../../../components/Image'
export default {
    components: { MImg },
    data() {
        return {
            keywords:'',
            page:1,
            total:0,
            size: 0,
            goodsSearch: '',
            goodsPage: 1,
            goodsTotal: 0,
            goodsSize: 0,
            tableData:[],
            dialog: false,
            start_time: '',
            end_time: '',
            id: '',
            timeDialog: false
        }
    },
    methods: {
        search() {
            this.page = 1;
            this.getData()
        },
        getData() {
            let params = {
                page: this.page,
                limit: 20,
            }
            if(this.keywords != '') {
                params.keywords = this.keywords
            }
            live_goods(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                    this.tableData.forEach(item => {
                        item.goods_sku.forEach(it => {
                            if(it.live_goods_sku) {
                                item.edit = 1
                            }
                        })
                    })
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        // 修改砍价商品上架状态
        handleStatus(row) {
            let params = {
                goods_id: row.goods_id,
                status: row.status,
                buy_status: row.buy_status,
            }
            put_live_goods(row.id,params).then(res => {
                if(res) {
                    this.$message({type:'success',message:'操作成功'})
                }
            })
        },
        // 修改排序
        handleSort(row) {
            let params = {
                sort: row.sort,
            }
            put_live_goods(row.id,params).then(res => {
                if(res) {
                    this.getData()
                    this.$message({type:'success',message:'操作成功'})
                }
            })
        },
        // 修改
        handlePut(row) {
            this.id = row.id
            this.timeDialog = true
            this.start_time = new Date(row.start_time)
            this.end_time = new Date(row.end_time)
        },
        // 确认修改
        handleBtn() {
            let params = {}
            if(this.start_time == '') {
                this.$message({type:'warning',message:'请选择开始时间'})
                return false
            }
            if(this.end_time == '') {
                this.$message({type:'warning',message:'请选择结束时间'})
                return false
            }
            params.start_time = parseTime(this.start_time)
            params.end_time = parseTime(this.end_time)
            put_live_goods(this.id, params).then(res => {
                if(res) {
                    this.$message({type:'success',message:'修改成功'})
                    this.timeDialog = false
                    this.getData()
                }
            })
        },
        handleSku(row) {
            this.$router.push({path:'/market/active/live/add',query: {id: row.id, name: row.goods_info.name}})
            sessionStorage.setItem('live_goods', JSON.stringify(row))
        },
        // 获取上架商品
        getSales() {
            let params = {
                page: this.goodsPage,
                status: 1,
            };
            if (this.goodsSearch != "") {
                params.search = this.goodsSearch;
            }
            goods_list(params).then((res) => {
                if (res) {
                    this.goodsData = res.data.data;
                    this.goodsData.forEach(item => {
                        item.pic_image = {
                            url: item.image_url,
                            id: item.image
                        }
                    })
                    this.goodsTotal = res.data.total;
                    this.goodsSize = res.data.per_page;
                } else {
                    this.goodsData = []
                }
                this.$forceUpdate();
            });
        },
        goodsMore(page) {
            this.goodsPage = page;
            this.getSales();
        },
        // 搜索上架商品
        searchGoods() {
            this.goodsPage = 1;
            this.getSales();
        },
        handleAdd(row) {
            let params = {
                goods_id: row.id,
            }
            if(this.start_time == '') {
                this.$message({type:'warning',message:'请选择开始时间'})
                return false
            }
            if(this.end_time == '') {
                this.$message({type:'warning',message:'请选择结束时间'})
                return false
            }
            params.start_time = parseTime(this.start_time)
            params.end_time = parseTime(this.end_time)
            add_live_goods(params).then(res => {
                if(res) {
                    this.$message({type:'success',message:'添加成功'})
                    this.getData()
                }
            })
        },
        // 单个删除
        handleDel(row, index) {
            this.$confirm(`此操作将移除商品： ${row.goods_info.name}, 是否继续?`, '提示', {
                type: 'error'
            }).then(() => {
                del_live_goods(row.id).then(res => {
                    if(res) {
                        this.$message({type:'success',message:'删除成功'})
                        this.tableData.splice(index, 1)
                    }
                })
            }).catch(() => {})
        }
    },
    created(){
        this.getData()
        this.getSales()
    },
    activated() {
        sessionStorage.removeItem('live_goods')
        this.getData()
        this.getSales()
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-radio-group {
    margin-right: 20px;
    .el-radio--medium.is-bordered {
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        margin-right: 10px;
        margin-left: 0;
    }
}
.tables-btns {
    display: flex;
    justify-content: center;
    .el-button {
        margin-right: 5px;
    }
}
.line-item {
    margin-top: 25px;
    &:nth-child(1){
        margin-top: 0;
    }
}
.item-label {
    height: 40px;
    line-height: 40px;
}
</style>


